import { Routes } from '@angular/router';

import { authGuard } from './guards/auth/auth.guard';
import { ShopLayoutComponent } from './layouts/shop/shop-layout.component';
import { ActivityLogComponent } from './pages/administration/activity-log/activity-log';
import { Administration } from './pages/administration/administration';
import { LandingManagment } from './pages/administration/landing-managment/landing-managment';
import { LoginComponent } from './pages/administration/login/login';
import { ManageCategoriesComponent } from './pages/administration/manage-categories/manage-categories';
import { ManageColorsComponent } from './pages/administration/manage-colors/manage-colors';
import { ManageKeychainsComponent } from './pages/administration/manage-keychains/manage-keychains';
import { OrdersHistory } from './pages/administration/orders-history/orders-history';
import { ProductFormComponent } from './pages/administration/product-form/product-form';
import { ShippingBoxesComponent } from './pages/administration/shipping-boxes/shipping-boxes';
import { ViewProducts } from './pages/administration/view-products/view-products';
import { Landing } from './pages/store/landing/landing';

export const routes: Routes = [
  {
    path: '',
    component: ShopLayoutComponent,
    children: [
      {
        path: '',
        component: Landing,
        pathMatch: 'full',
      },
      {
        path: 'home',
        redirectTo: '',
        pathMatch: 'full',
      },
      {
        path: 'catalogo',
        loadComponent: () => import('./pages/store/catalog/catalog').then((module) => module.Catalog),
      },
      {
        path: 'catalogo/:productSlug',
        loadComponent: () =>
          import('./pages/store/catalog/product-detail/product-detail').then(
            (module) => module.ProductDetailViewComponent,
          ),
      },
      {
        path: 'pago',
        loadComponent: () =>
          import('./pages/store/checkout/checkout').then((module) => module.CheckoutComponent),
      },
      {
        path: 'pago/retorno/:orderId',
        data: { mode: 'return' },
        loadComponent: () =>
          import('./pages/store/checkout/checkout-return/checkout-return').then(
            (module) => module.CheckoutReturnComponent,
          ),
      },
      {
        path: 'pago/cancelado/:orderId',
        data: { mode: 'cancel' },
        loadComponent: () =>
          import('./pages/store/checkout/checkout-return/checkout-return').then(
            (module) => module.CheckoutReturnComponent,
          ),
      },
      {
        path: 'encargo',
        loadComponent: () =>
          import('./pages/custom-design/custom-design').then((module) => module.CustomDesignComponent),
      },
    ],
  },
  {
    path: 'administracion/iniciar-sesion',
    component: LoginComponent,
  },
  {
    path: 'administracion',
    component: Administration,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'productos/detalle',
      },
      {
        path: 'productos/detalle',
        component: ViewProducts,
        canActivate: [authGuard],
      },
      {
        path: 'productos/crear',
        component: ProductFormComponent,
        canActivate: [authGuard],
      },
      {
        path: 'productos/editar/:slug',
        component: ProductFormComponent,
        canActivate: [authGuard],
      },
      {
        path: 'colores',
        component: ManageColorsComponent,
        canActivate: [authGuard],
      },
      {
        path: 'categorias',
        component: ManageCategoriesComponent,
        canActivate: [authGuard],
      },
      {
        path: 'llaveros',
        component: ManageKeychainsComponent,
        canActivate: [authGuard],
      },
      {
        path: 'cajas-envio',
        component: ShippingBoxesComponent,
        canActivate: [authGuard],
      },
      {
        path: 'pedidos',
        component: OrdersHistory,
        canActivate: [authGuard],
      },
      {
        path: 'pagina-principal',
        component: LandingManagment,
        canActivate: [authGuard],
      },
      {
        path: 'registro-actividad',
        component: ActivityLogComponent,
        canActivate: [authGuard],
      },
      {
        path: 'auth/success',
        redirectTo: '',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: '**',
    title: 'Página no encontrada | Argentus Mundo 3D',
    loadComponent: () =>
      import('./pages/not-found/not-found').then((module) => module.NotFoundComponent),
  },
];
